export default {
  infoLabel: 'Component Information',
  closeLabel: 'Close Information',
  profilePicture: 'Profile Picture',
  name: 'Name',
  username: 'Username',
  interactions: 'Total',
  comments: 'Comments',
  inboxes: 'Inboxes',
  page: 'Page',
  channel: 'Channel',
  polarity: 'Polarity',
  posts: 'Posts',
  faq: {
    faq01: {
      title: 'Where does the data in the table come from?',
      description: 'From the area of users most engaged with Proprietary Metrics',
    },
    faq02: {
      title: 'Which channels can this data be used for?',
      description: 'Instagram and Facebook',
    },
    faq03: {
      title: 'What does the Total column mean?',
      description: 'Total is the sum of posts, comments, and inboxes',
    },
  },
};
